import EditIcon from '../../../../utils/media/icons/edit_icon.png';
import DeleteIcon from '../../../../utils/media/icons/delete_icon.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Chip from '../../../../components/Chip';
import { deleteEventCategory } from '../../../../api/events';

const TableList = ({ data, setData, toast }) => {

  const navigate = useNavigate();

  const [selectedRows, setSelectedRows] = useState(new Set());

  const renderChips = (status) => {
    if (status === true) {
      return <Chip value={'Active'} color='green' />
    } else if (status === false) {
      return <Chip value={'Inactive'} color='inactive' />
    }
  }

  const toggleSelectAll = () => {
    if (selectedRows.size === data.length) {
      setSelectedRows(new Set());
    } else {
      setSelectedRows(new Set(data.map(user => user._id)));
    }
  };

  const toggleSelectRow = (id) => {
    const newSelected = new Set(selectedRows);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelectedRows(newSelected);
  };

  const handleDelete = (id) => {
    const conf = window.confirm('Are you sure you want to delete this category?');
    if (conf) {
      deleteEventCategory(id, setData, toast);
    }
  }

  return (
    <div className="overflow-x-auto mt-2">
      <table className="w-full border-collapse" role="table">
        <thead className="bg-navBtn">
          <tr className="rounded-md">
            {/* <th className="p-3 text-left">
              <input
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 accent-primary"
                checked={selectedRows.size === data.length}
                onChange={toggleSelectAll}
                aria-label="Select all data"
              />
            </th> */}
            <th className="p-3 text-left">Srl. No.</th>
            <th className="p-3 text-left">Icon</th>
            <th className="p-3 text-left">Event Category</th>
            <th className="p-3 text-left">Category Description</th>
            <th className="p-3 text-center">Status</th>
            <th className="p-3 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, id) => (
            <tr
              key={item._id}
              className="border-b border-navBtn hover:bg-gray-50"
            >
              {/* <td className="p-3">
                <input
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 accent-primary mt-1"
                  checked={selectedRows.has(item._id)}
                  onChange={() => toggleSelectRow(item._id)}
                  aria-label={`Select ${item.name}`}
                />
              </td> */}
              <td className="p-3">{++id}</td>
              <td className="p-3">
                {
                  item?.logo ?
                  <img src={item.logo} alt="category" className='w-8 h-8 rounded-full' />
                  : "-"
                }
              </td>
              <td className="p-3">{item.name}</td>
              <td className="p-3">{item.description.length > 100 ? item.description.slice(0, 70) + '...' : item.description}</td>
              <td className="p-3 flex items-center justify-center">
                {/* <div className={`flex justify-center items-center border border-${item.active ? `primary` : `inactive`} rounded-md h-full min-h-10 min-w-40 max-w-fit`}>
                  <label className="inline-flex items-center me-5 cursor-pointer h-full">
                    <span className={`ms-3 text-base text-${item.active ? `primary` : 'inactive'} font-bold dark:text-gray-300 mr-2`}>{item.active ? 'Active' : 'Inactive'}</span>
                    <input type="checkbox" name={'active'} value={item.active} className="sr-only peer" checked={item.active} readOnly />
                    <div className="relative w-11 h-6 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                  </label>
                </div> */}
                {renderChips(item.active)}
              </td>
              <td className="p-3 min-w-24">
                <button className="rounded p-1.5 bg-[rgba(0,122,155,0.1)] hover:bg-[rgba(0,122,155,0.2)] min-h-7 mr-1" onClick={() => navigate('/events/event-categories/create-categories', { state: { _id: item._id } })}>
                  <img src={EditIcon} alt="edit" />
                </button>
                {/* <button className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7" onClick={() => navigate('/item/view/item', { state: { _id: item._id } })}>
                  <img src={ViewIcon} alt="view" />
                </button> */}
                <button className="rounded p-1.5 bg-[rgba(250,22,22,0.1)] hover:bg-[rgba(250,22,22,0.2)] min-h-7 ml-1 px-2" onClick={() => handleDelete(item._id)}>
                  <img src={DeleteIcon} alt="delete" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableList;